<template>
  <div class="mypage" data-tab-wrap>
    <section class="ttl-bg-color">
      <div class="ttl-bg-color__inner">
        <h1 class="ttl-bg-color__ttl">マイ機能</h1>
      </div>
    </section>

    <nav class="tab is-two">
      <ul class="tab__list">
        <li class="tab__item">
          <span data-tab="favorite" class="tab__link">お気に入り</span>
        </li>
        <li class="tab__item">
          <span data-tab="browsing" class="tab__link">閲覧履歴</span>
        </li>
      </ul>
    </nav>

    <section class="chart">
      <div class="chart__wrap">
        <div class="mypage__content" data-tab-content="favorite">
        <CompanyList
            @unlike="unlike"
            :company_info="pageData.favorites"
            :options="favoriteOptions"></CompanyList>
        </div>
        <div class="mypage__content" data-tab-content="browsing">
        <CompanyList
            @like="like"
            @unlike="unlike"
            :company_info="pageData.browsings"
            :options="browsingOptions"></CompanyList>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup lang="ts">
import CompanyList from "../parts/CompanyList.vue";
import {usePageStore} from "../../stores/page";
import {Storage} from "../../localstorage/Storage";
import {onMounted, ref} from "vue";
import { remove,each,update } from 'es-toolkit/compat';


const favoriteOptions = {share: true, like_delete: true};
const browsingOptions = {share: true, like: true, history_delete: true};

onMounted(()=>{
  changeHash();
  window.addEventListener('hashchange',changeHash);
})

const changeHash = (e?)=>{
  let type = 'favorite';
  if(location.hash=='#browsing'){
    type = 'browsing';
  }
  document.querySelector('.mypage').dataset.type = type;
}

let pageData;
if (globalThis.IS_USER_LOGIN) {
  const pageDataStore = usePageStore();
  pageData = pageDataStore.pageData;
} else {
  let data = Storage.getData();
  pageData = ref({
    "favorites": data.favorite,
    "browsings": data.history
  });
}

const like = (company) => {
  if (globalThis.IS_USER_LOGIN) {
    pageData.favorites.unshift(company.value)
  }else{
    let data = Storage.getData()
    pageData.value.favorites = data.favorite
  }
  
}
const unlike = (company) => {
  if (globalThis.IS_USER_LOGIN) {
    remove(pageData.favorites, (c: any) => {
      return c.company_id == company.value.company_id
    });
    each(pageData.browsings,(c:any)=>{
       if(c.company_id == company.value.company_id){
         c.favorite_status = false
       }
    })
    // console.log(pageData.favorites.length);
  }else{
    let data = Storage.getData()
    pageData.value.favorites = data.favorite
  }
  
}


</script>